var map = {
	"./black/xiazaijietu2.png": "m05d",
	"./blue/xiazaijietu2.png": "crE8",
	"./white/xiazaijietu2.png": "9RlR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w+V2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/xiazaijietu2\.png$
// module id = w+V2
// module chunks = 24